var map = {
	"./belgianFlag.ico": 7256,
	"./belgianFlag.svg": 18,
	"./changeManagement.jpeg": 5277,
	"./changeManagement.jpg": 4262,
	"./changeManagementBlocks.jpeg": 5188,
	"./changeManagementPrevious.jpg": 1026,
	"./dutchFlag.ico": 351,
	"./dutchFlag.svg": 6513,
	"./europeanFlag.ico": 7318,
	"./europeanFlag.svg": 7474,
	"./homeCover.jpeg": 1729,
	"./homeCover2.jpeg": 9268,
	"./luxemburgFlag.ico": 4907,
	"./luxemburgFlag.svg": 4227,
	"./procurement.jpg": 4302,
	"./sustainability.jpg": 4140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;